import { SuccessFetchListResponse } from "@/services/api";
import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";

export default function usePaginatedList<T>(
  query: UseInfiniteQueryResult<
    InfiniteData<SuccessFetchListResponse<T>>,
    unknown
  >,
) {
  return query.data?.pages.flatMap(({ items }) => items) || [];
}
